export const SHORT_DISCLAIMER =
  "Balangir Group is a B2B marketplace aggregator only. We connect employers with independent employees and security personnel and are not their employer, contractor or principal employer. The hiring employer is solely responsible for all medical, safety and workplace liabilities, including medical fitness checks, injuries, accidents, insurance, wages and statutory compliance.";

export const DISCLAIMER_SECTIONS = [
  {
    id: "aggregator-role",
    title: "1. Our role: B2B marketplace aggregator",
    body: [
      "Balangir Group (balangirgroup.com) operates an online B2B platform that connects employers — such as factories, mills, malls, multiplexes, construction sites, warehouses, hotels and hospitals — with independent job seekers, skilled and unskilled employees and security personnel.",
      "We act only as an intermediary. We are not the employer, contractor, sub-contractor, principal employer or agent of any candidate, and no employer–employee relationship is created between Balangir Group and any employee or candidate.",
    ],
  },
  {
    id: "employer-responsibility",
    title: "2. Employment responsibility rests with the hiring employer",
    body: [
      "The decision to hire, the terms of engagement, supervision, working hours, wages, allowances and termination are decided and controlled solely by the hiring employer.",
      "The hiring employer is fully responsible for compliance with all applicable labour, wage, social security and industry laws, including PF, ESIC, minimum wages, contract labour rules and, for security personnel, private security agency regulations.",
    ],
  },
  {
    id: "medical-liability",
    title: "3. Medical liability",
    body: [
      "The hiring employer is solely responsible for pre-employment and periodic medical fitness checks, first aid, medical emergencies, hospitalisation, treatment costs and any occupational illness of employees engaged at its site.",
      "Balangir Group does not certify the medical or physical fitness of any candidate. Height, weight and other details shown on the platform are self-declared.",
    ],
  },
  {
    id: "safety-liability",
    title: "4. Safety and workplace liability",
    body: [
      "The hiring employer is solely responsible for workplace safety, safety training, personal protective equipment and uniforms, safe machinery and premises, and compliance with fire, building and factory safety rules.",
      "Any accident, injury, disability, death, damage to property, theft or loss occurring at or in connection with the employer's workplace is the sole liability of the hiring employer, including compensation and insurance under applicable law.",
    ],
  },
  {
    id: "verification",
    title: "5. Verification and conduct",
    body: [
      "KYC documents and phone verification on the platform are basic checks only. The hiring employer must carry out its own background, police and reference verification before deployment.",
      "Balangir Group does not guarantee the conduct, skill, performance, attendance or honesty of any employee, nor the conduct or payment obligations of any employer.",
    ],
  },
  {
    id: "limitation",
    title: "6. Limitation of liability and indemnity",
    body: [
      "To the maximum extent permitted by law, Balangir Group, its owners and staff are not liable for any direct, indirect or consequential loss arising from any engagement made through the platform. Any liability of Balangir Group is limited to the platform fees actually paid for the specific service in question.",
      "By using the platform, the hiring employer agrees to indemnify and hold Balangir Group harmless against any claim, penalty or proceeding arising from its engagement of employees, including medical, safety and workplace claims.",
    ],
  },
  {
    id: "acceptance",
    title: "7. Acceptance",
    body: [
      "By registering, posting a requirement, unlocking a contact or engaging any candidate through Balangir Group, you confirm that you have read and accepted this disclaimer.",
    ],
  },
];
